import html2canvas from "html2canvas";

export class WaterMarkCanvas {
  static CANVAS_WIDTH = 1600;
  static CANVAS_HEIGHT = 900;

  static setStyle = function(ele, style) {
    if (!ele || !ele.style) return;
    for (var styleKey in style) {
      if (style.hasOwnProperty(styleKey)) {
        ele.style[styleKey] = style[styleKey];
      }
    }
  };
  static setWAH = function(ele, width, height) {
    if (!ele) return;
    ele.width = width;
    ele.height = height;
    ele.style.width = width + "px";
    ele.style.height = height + "px";
  };
  static wait = function(getEle, func, times, interval) {
    if (typeof getEle !== "function") return;
    var _times = times || -1, //100娆�
      _interval = interval || 20, //20姣姣忔
      _self = this,
      _iIntervalID; //瀹氭椂鍣╥d
    if (getEle()) {
      //濡傛灉宸茬粡鑾峰彇鍒颁簡锛屽氨鐩存帴鎵ц鍑芥暟
      func && func.call(this);
    } else {
      _iIntervalID = setInterval(function() {
        if (!_times) {
          //鏄�0灏遍€€鍑�
          clearInterval(_iIntervalID);
        }
        _times <= 0 || _times--; //濡傛灉鏄鏁板氨 --

        if (getEle()) {
          // 鍐嶆閫夋嫨,鍒ゆ柇鏄惁鍙栧埌
          func && func.call(_self);
          clearInterval(_iIntervalID);
        }
      }, _interval);
    }
    return this;
  };

  constructor(options) {
    this.wmId = "wea_watremark_" + parseInt(Math.random() * 1000);
    this.options = options;
    this.cache = {};
  }

  // 缁樺埗canvas鏍峰紡
  drawCanvas = () => {
    //Draw canvas
    var canvas = document.createElement("canvas");
    canvas.style.width = WaterMarkCanvas.CANVAS_WIDTH + "px";
    canvas.style.height = WaterMarkCanvas.CANVAS_HEIGHT + "px";
    canvas.width = WaterMarkCanvas.CANVAS_WIDTH;
    canvas.height = WaterMarkCanvas.CANVAS_HEIGHT;
    canvas.id = this.wmId;
    canvas.style.display = "block";
    canvas.style.pointerEvents = "none";
    canvas.style.position = "fixed";
    canvas.style.zIndex = 99999;
    canvas.style.top = 0;
    canvas.style.left = 0;
    canvas.style.textAlign = "center";
    return canvas;
  };
  // 缁樺埗鏂囨湰姘村嵃
  drawTextWatermark = options => {
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var canvas = this.drawCanvas();
    var ctx = canvas.getContext("2d");
    ctx.clearRect(
      0,
      0,
      WaterMarkCanvas.CANVAS_WIDTH,
      WaterMarkCanvas.CANVAS_HEIGHT
    );
    ctx.save();
    ctx.scale(
      WaterMarkCanvas.CANVAS_WIDTH / windowWidth,
      WaterMarkCanvas.CANVAS_HEIGHT / windowHeight
    );
    var width = this.options.width > 0 ? this.options.width : 200;
    var height = this.options.height > 0 ? this.options.height : 150;
    var rotate = ((this.options.rotate || 0) / 360) * Math.PI;
    var text = this.options.text;
    var w = WaterMarkCanvas.CANVAS_WIDTH;
    var h = WaterMarkCanvas.CANVAS_HEIGHT;

    var x = Math.ceil(w / width);
    var y = Math.ceil(h / height);

    ctx.textAlign = "center";
    // ctx.font= 'px yahei';
    ctx.globalAlpha = this.options.alpha;
    ctx.rotate(rotate);
    for (var i = 0; i < x; i += 1) {
      for (var j = 0; j < y; j += 1) {
        ctx.fillText(text, i * width, j * height, width);
      }
    }
    ctx.restore();
    document.body.appendChild(canvas);
  };
  // 灏嗘寚瀹歞om鍏冪礌鐢熸垚canvas鍥剧墖
  loadWatermarkWithCanvas = (watermarkContentId, layout, callback) => {
    console.time("canvas wm wait dom load");
    layout = layout || document;
    WaterMarkCanvas.wait(
      () => {
        return layout.getElementById(watermarkContentId);
      },
      () => {
        console.timeEnd("canvas wm wait dom load");
        console.time("canvas wm wait html to canvas");
        var getPixelRatio = function(context) {
          // 鑾峰彇璁惧鐨凱ixelRatio
          var backingStore =
            context.backingStorePixelRatio ||
            context.webkitBackingStorePixelRatio ||
            context.mozBackingStorePixelRatio ||
            context.msBackingStorePixelRatio ||
            context.oBackingStorePixelRatio ||
            context.backingStorePixelRatio ||
            1;
          return (window.devicePixelRatio || 1) / backingStore;
        };
        var shareContent = layout.getElementById(watermarkContentId);
        var width = shareContent.offsetWidth;
        var height = shareContent.offsetHeight;
        var canvas = document.createElement("canvas");
        var context = canvas.getContext("2d");
        // 灏哻anvas鐨勫鍣ㄦ墿澶ixelRatio鍊嶏紝鍐嶅皢鐢诲竷缂╂斁锛屽皢鍥惧儚鏀惧ぇPixelRatio鍊嶏紝闃叉瀵煎嚭鐨勫浘鐗囨ā绯�
        var scale = getPixelRatio(context);
        context.scale(scale, scale);
        WaterMarkCanvas.setWAH(canvas, width * scale, height * scale);
        var opts = {
          backgroundColor: null,
          scale: scale,
          canvas: canvas,
          width: width,
          height: height,
          useCORS: true,
          dpi: window.devicePixelRatio,
          ignoreElements: element => {
            /* 过滤图片下载插件的iframe，防止图片重复下载问题 */
            if (element.id == "downloadFrame") {
              return true;
            }
          }
        };
        html2canvas(shareContent, opts).then(canvas => {
          console.timeEnd("canvas wm wait html to canvas");
          this.canvas = canvas;
          var context = canvas.getContext("2d");
          // 鍏抽棴鎶楅敮榻垮舰
          context.mozImageSmoothingEnabled = false;
          context.webkitImageSmoothingEnabled = false;
          context.msImageSmoothingEnabled = false;
          context.imageSmoothingEnabled = false;
          this.cache.width = width;
          this.cache.height = height;
          this.cache.scale = scale;
          this.loadWatermarkToImage(canvas, callback);
        });
      }
    );
  };
  loadWatermarkToImage = (canvas, callback) => {
    console.time("canvas wm canvas to image");
    canvas = canvas || this.canvas;
    // canvas杞寲涓哄浘鐗�
    var newImg = Canvas2Image.convertToImage(canvas);
    // 缁欏浘鐗囪缃師濮嬬殑瀹介珮
    newImg.style.all = "initial";
    WaterMarkCanvas.setWAH(newImg, this.cache.width, this.cache.height);
    WaterMarkCanvas.setStyle(newImg, {
      display: "block",
      pointerEvents: "none",
      textAlign: "center",
      position: "fixed",
      zIndex: 99999,
      top: 0,
      left: 0
    });
    console.timeEnd("canvas wm canvas to image");
    if (callback) callback(newImg, canvas);
  };
}

/**
 * covert canvas to image
 * and save the image file
 */
export var Canvas2Image = (function() {
  // check if support sth.
  var $support = (function() {
    var canvas = document.createElement("canvas"),
      ctx = canvas.getContext("2d");

    return {
      canvas: !!ctx,
      imageData: !!ctx.getImageData,
      dataURL: !!canvas.toDataURL,
      btoa: !!window.btoa
    };
  })();

  var downloadMime = "image/octet-stream";

  function scaleCanvas(canvas, width, height) {
    var w = canvas.width,
      h = canvas.height;
    if (width == undefined) {
      width = w;
    }
    if (height == undefined) {
      height = h;
    }

    var retCanvas = document.createElement("canvas");
    var retCtx = retCanvas.getContext("2d");
    retCanvas.width = width;
    retCanvas.height = height;
    retCtx.drawImage(canvas, 0, 0, w, h, 0, 0, width, height);
    return retCanvas;
  }

  function getDataURL(canvas, type, width, height) {
    canvas = scaleCanvas(canvas, width, height);
    return canvas.toDataURL(type);
  }

  function saveFile(strData) {
    document.location.href = strData;
  }

  function genImage(strData) {
    var img = document.createElement("img");
    img.src = strData;
    return img;
  }
  function fixType(type) {
    type = type.toLowerCase().replace(/jpg/i, "jpeg");
    var r = type.match(/png|jpeg|bmp|gif/)[0];
    return "image/" + r;
  }
  function encodeData(data) {
    if (!window.btoa) {
      throw "btoa undefined";
    }
    var str = "";
    if (typeof data == "string") {
      str = data;
    } else {
      for (var i = 0; i < data.length; i++) {
        str += String.fromCharCode(data[i]);
      }
    }

    return btoa(str);
  }
  function getImageData(canvas) {
    var w = canvas.width,
      h = canvas.height;
    return canvas.getContext("2d").getImageData(0, 0, w, h);
  }
  function makeURI(strData, type) {
    return "data:" + type + ";base64," + strData;
  }

  /**
   * create bitmap image
   * 閹稿鍙庣憴鍕灟閻㈢喐鍨氶崶鍓у閸濆秴绨叉径鏉戞嫲閸濆秴绨叉担锟�
   */
  var genBitmapImage = function(oData) {
    //
    // BITMAPFILEHEADER: http://msdn.microsoft.com/en-us/library/windows/desktop/dd183374(v=vs.85).aspx
    // BITMAPINFOHEADER: http://msdn.microsoft.com/en-us/library/dd183376.aspx
    //

    var biWidth = oData.width;
    var biHeight = oData.height;
    var biSizeImage = biWidth * biHeight * 3;
    var bfSize = biSizeImage + 54; // total header size = 54 bytes

    //
    //  typedef struct tagBITMAPFILEHEADER {
    //  	WORD bfType;
    //  	DWORD bfSize;
    //  	WORD bfReserved1;
    //  	WORD bfReserved2;
    //  	DWORD bfOffBits;
    //  } BITMAPFILEHEADER;
    //
    var BITMAPFILEHEADER = [
      // WORD bfType -- The file type signature; must be "BM"
      0x42,
      0x4d,
      // DWORD bfSize -- The size, in bytes, of the bitmap file
      bfSize & 0xff,
      (bfSize >> 8) & 0xff,
      (bfSize >> 16) & 0xff,
      (bfSize >> 24) & 0xff,
      // WORD bfReserved1 -- Reserved; must be zero
      0,
      0,
      // WORD bfReserved2 -- Reserved; must be zero
      0,
      0,
      // DWORD bfOffBits -- The offset, in bytes, from the beginning of the BITMAPFILEHEADER structure to the bitmap bits.
      54,
      0,
      0,
      0
    ];

    //
    //  typedef struct tagBITMAPINFOHEADER {
    //  	DWORD biSize;
    //  	LONG  biWidth;
    //  	LONG  biHeight;
    //  	WORD  biPlanes;
    //  	WORD  biBitCount;
    //  	DWORD biCompression;
    //  	DWORD biSizeImage;
    //  	LONG  biXPelsPerMeter;
    //  	LONG  biYPelsPerMeter;
    //  	DWORD biClrUsed;
    //  	DWORD biClrImportant;
    //  } BITMAPINFOHEADER, *PBITMAPINFOHEADER;
    //
    var BITMAPINFOHEADER = [
      // DWORD biSize -- The number of bytes required by the structure
      40,
      0,
      0,
      0,
      // LONG biWidth -- The width of the bitmap, in pixels
      biWidth & 0xff,
      (biWidth >> 8) & 0xff,
      (biWidth >> 16) & 0xff,
      (biWidth >> 24) & 0xff,
      // LONG biHeight -- The height of the bitmap, in pixels
      biHeight & 0xff,
      (biHeight >> 8) & 0xff,
      (biHeight >> 16) & 0xff,
      (biHeight >> 24) & 0xff,
      // WORD biPlanes -- The number of planes for the target device. This value must be set to 1
      1,
      0,
      // WORD biBitCount -- The number of bits-per-pixel, 24 bits-per-pixel -- the bitmap
      // has a maximum of 2^24 colors (16777216, Truecolor)
      24,
      0,
      // DWORD biCompression -- The type of compression, BI_RGB (code 0) -- uncompressed
      0,
      0,
      0,
      0,
      // DWORD biSizeImage -- The size, in bytes, of the image. This may be set to zero for BI_RGB bitmaps
      biSizeImage & 0xff,
      (biSizeImage >> 8) & 0xff,
      (biSizeImage >> 16) & 0xff,
      (biSizeImage >> 24) & 0xff,
      // LONG biXPelsPerMeter, unused
      0,
      0,
      0,
      0,
      // LONG biYPelsPerMeter, unused
      0,
      0,
      0,
      0,
      // DWORD biClrUsed, the number of color indexes of palette, unused
      0,
      0,
      0,
      0,
      // DWORD biClrImportant, unused
      0,
      0,
      0,
      0
    ];

    var iPadding = (4 - ((biWidth * 3) % 4)) % 4;

    var aImgData = oData.data;

    var strPixelData = "";
    var biWidth4 = biWidth << 2;
    var y = biHeight;
    var fromCharCode = String.fromCharCode;

    do {
      var iOffsetY = biWidth4 * (y - 1);
      var strPixelRow = "";
      for (var x = 0; x < biWidth; x++) {
        var iOffsetX = x << 2;
        strPixelRow +=
          fromCharCode(aImgData[iOffsetY + iOffsetX + 2]) +
          fromCharCode(aImgData[iOffsetY + iOffsetX + 1]) +
          fromCharCode(aImgData[iOffsetY + iOffsetX]);
      }

      for (var c = 0; c < iPadding; c++) {
        strPixelRow += String.fromCharCode(0);
      }

      strPixelData += strPixelRow;
    } while (--y);

    var strEncoded =
      encodeData(BITMAPFILEHEADER.concat(BITMAPINFOHEADER)) +
      encodeData(strPixelData);

    return strEncoded;
  };

  /**
   * saveAsImage
   * @param canvasElement
   * @param {String} image type
   * @param {Number} [optional] png width
   * @param {Number} [optional] png height
   */
  var saveAsImage = function(canvas, width, height, type) {
    if ($support.canvas && $support.dataURL) {
      if (typeof canvas == "string") {
        canvas = document.getElementById(canvas);
      }
      if (type == undefined) {
        type = "png";
      }
      type = fixType(type);
      if (/bmp/.test(type)) {
        var data = getImageData(scaleCanvas(canvas, width, height));
        var strData = genBitmapImage(data);
        saveFile(makeURI(strData, downloadMime));
      } else {
        var strData = getDataURL(canvas, type, width, height);
        saveFile(strData.replace(type, downloadMime));
      }
    }
  };

  var convertToImage = function(canvas, width, height, type) {
    if ($support.canvas && $support.dataURL) {
      if (typeof canvas == "string") {
        canvas = document.getElementById(canvas);
      }
      if (type == undefined) {
        type = "png";
      }
      type = fixType(type);

      if (/bmp/.test(type)) {
        var data = getImageData(scaleCanvas(canvas, width, height));
        var strData = genBitmapImage(data);
        return genImage(makeURI(strData, "image/bmp"));
      } else {
        var strData = getDataURL(canvas, type, width, height);
        return genImage(strData);
      }
    }
  };

  return {
    saveAsImage: saveAsImage,
    saveAsPNG: function(canvas, width, height) {
      return saveAsImage(canvas, width, height, "png");
    },
    saveAsJPEG: function(canvas, width, height) {
      return saveAsImage(canvas, width, height, "jpeg");
    },
    saveAsGIF: function(canvas, width, height) {
      return saveAsImage(canvas, width, height, "gif");
    },
    saveAsBMP: function(canvas, width, height) {
      return saveAsImage(canvas, width, height, "bmp");
    },

    convertToImage: convertToImage,
    convertToPNG: function(canvas, width, height) {
      return convertToImage(canvas, width, height, "png");
    },
    convertToJPEG: function(canvas, width, height) {
      return convertToImage(canvas, width, height, "jpeg");
    },
    convertToGIF: function(canvas, width, height) {
      return convertToImage(canvas, width, height, "gif");
    },
    convertToBMP: function(canvas, width, height) {
      return convertToImage(canvas, width, height, "bmp");
    }
  };
})();



// WEBPACK FOOTER //
// ./ecology9/wea-tools/html2image.js